import { z } from "zod";
import { EmailAddressSchema, ProviderIdSchema, StripeCustomerId, StripeSubscriptionId, UserIdSchema, } from "./branded.js";
import { UserRoleSchema } from "./role.js";
export const UserPreferencesSchema = z.object({
    defaultProvider: ProviderIdSchema.optional(),
    timezone: z.string().default("UTC"),
    dateFormat: z.string().default("YYYY-MM-DD"),
    theme: z.enum(["light", "dark", "system"]).default("system"),
    /**
     * Admins only. `false` makes an admin behave like a regular user on their own plan (to test
     * Free), everywhere: dashboard and MCP. Unset means on. Ignored for every other role.
     */
    adminMode: z.boolean().optional(),
});
export const UserSchema = z.object({
    id: UserIdSchema,
    email: EmailAddressSchema,
    // zod 4 infers a transformed/`X | undefined` field as a REQUIRED key (value
    // may be undefined), whereas zod 3 made the key optional. These fields are
    // genuinely optional on User, so `.optional()` must be the outermost wrapper
    // to keep the inferred key optional (`stripeCustomerId?: …`).
    stripeCustomerId: z
        .string()
        .transform((val) => StripeCustomerId(val))
        .optional(),
    stripeSubscriptionId: z
        .string()
        .transform((val) => StripeSubscriptionId(val))
        .optional(),
    subscriptionTier: z.string(),
    subscriptionStatus: z.string(),
    currentPeriodEnd: z.date().optional(),
    connectedProviders: z.array(ProviderIdSchema),
    preferences: UserPreferencesSchema,
    accessLevel: z.enum(["readonly", "readwrite"]),
    role: UserRoleSchema.default("user"),
    giftedBy: UserIdSchema.optional(),
    giftedUntil: z.date().optional(),
    giftedTier: z.string().optional(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
export const UserTokenDataSchema = z.object({
    userId: UserIdSchema,
    provider: ProviderIdSchema,
    encryptedAccessToken: z.string(),
    encryptedRefreshToken: z.string(),
    expiresAt: z.date(),
    scopes: z.array(z.string()),
    lastRefresh: z.date(),
    refreshFailureCount: z.number().default(0),
    createdAt: z.date(),
    updatedAt: z.date(),
});
//# sourceMappingURL=user.js.map